import { Component, EventEmitter, Output } from '@angular/core';
import { ISidebarItem } from '../../../../nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';

@Component({
  selector: 'shelter-network-settings-left-nav',
  template: require('./shelter-network-settings-left-nav.component.html'),
  styles: [require('./shelter-network-settings-left-nav.component.scss')],
})
export class ShelterNetworkSettingsLeftNavComponent {
  @Output() onBack: EventEmitter<string> = new EventEmitter<string>();
  public title: string = 'network';
  public sidebarItems: ISidebarItem[] = [
    {
      key: 'User permissions',
      human: 'User permissions',
    },
  ];

  public back(): void {
    this.onBack.emit('shelter-picker');
  }
}
